import React from "react"
import { graphql } from "gatsby"
import parse from "html-react-parser"
import StructuredText from "../custom-structured-text-renderer"

const BasicText = ({ heading, richText }) => {
  return (
    <section className="basic-text">
      <div className="basic-text__inner">
        <div className='basic-text__wrapper'>
          {heading && <h1>{parse(heading)}</h1>}
          {richText && <StructuredText data={richText} />}
        </div>
      </div>
    </section>
  )
}

export default BasicText

export const query = graphql`
fragment BasicTextProps on DatoCmsBasicText {
  ... on DatoCmsBasicText {
    id
    heading
    richText {
      value
    }
  }
}
`